import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from 'partnerhub';
import { Observable } from 'rxjs';
import { filter, pluck } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Bundle, Product } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class BundleService {
  
  public baseURL = environment.serverApiBaseUrl;
  
  constructor(private readonly http: HttpClient, private readonly helperService: HelperService) {}

  private mapOfferList(offerList: any[] = []): any[] {
    return offerList
      .filter((value) => value.id !== '')
      .map((value) => ({
        id: value.id,
        activeByDefault: value.default,
        automaticActivation: value.auto,
        points: value.points ? parseInt(value.points, 10) : 0,
      }));
  }

  public createBundle(bundle: any, banner?: any): Observable<any> {
    const url = `/api/webapp-partnerhub-admin/bundles`;

    const body = {
      name: bundle.bundlesDetails.bundleName,
      countryId: bundle.countryOperator.country.countryId,
      countryName: bundle.countryOperator.country.name,
      operatorId: bundle.countryOperator.operator.id,
      operatorName: bundle.countryOperator.operator.name,
      partnerId: 1289, // TODO: Remove Hardcoded
      partnerName: '',
      plan: bundle.bundlesDetails.plan.key,
      givePoints: true,
      allowsProductChange: true,
      maxProductChange: 10,
      category: bundle.bundlesDetails.bundleMainCategory.name,
      type: {
        id: bundle.bundlesDetails.bundleType.id,
        name: bundle.bundlesDetails.bundleType.name,
      },
      offers: this.mapOfferList(bundle.offerList),

      bundleOffers: bundle.offers.map((offer) => {
        return {
          name: offer.details.offerName,
          type: {
            id: offer.details.offerType.id,
            name: offer.details.offerType.name,
            productTypeId: offer.details.offerType.productTypeId,
          },
          frequency: offer.details.periods.name,

          languages: offer.details.languages,
          keywords: [], // TODO: Keywords needs enligthment
          costModels: [
            {
              event: 'activation',
              revenueModel: 'fixedCost',
              revenueModelAmmount: '1',
              condition: {
                id: 2,
                name: 'Days',
              },
              from: '1',
              to: '1',
            },
          ],
          priceModel: {
            activationPrice: {
              value: offer.details.activationPrice,
              currencyType: {
                type: '$',
              },
            },
            renewalPrice: {
              value: offer.details.renewalPrice,
              currencyType: {
                type: '$',
              },
            },
          },
          messages: [
            {
              type: 'SUB_OPTIN',
              content: offer.communication.welcomeMessage,
            },
            {
              type: 'BILLING',
              content: offer.communication.billingMessage,
            },
            {
              type: 'HELP',
              content: offer.communication.helpMessage,
            },
            {
              type: 'SUB_PRE_OPTIN',
              content: offer.communication.doubleOptMessage,
            },
            {
              type: 'MSG_BLACKLISTED',
              content: offer.communication.blacklistMessage,
            },
            {
              type: 'REFUND',
              content: offer.communication.refundMessage,
            },
            {
              type: 'PRODUCT_SWITCH',
              content: offer.communication.productSwitchMessage,
            },
          ],
          period: {
            type: offer.details.periods.name,
            value: offer.details.advancedPeriod,
          },
          shortCodes: [], // TODO: Waiting for BE
          channels: offer.communication.entryChannels,
          pointsModel: {
            onActivation: offer.details.activationPoints,
            onRenewal: offer.details.renewalPoints,
          },
        };
      }),
    };

    return this.http.post<any>(url, body);
  }

  public newCreateBundle(formValues){
    const url = `/${this.baseURL}/bundle/create`;
    let bundle = this.formatBundleObj(formValues)
    return this.http.post(url, bundle);
  }

  private formatBundleObj(formValues): Bundle{
    let bundle: Bundle = {
      billingCompany: formValues.billingCompany.name,
      blacklistBypass: formValues.blacklistBypass,
      cancelBypass: formValues.cancelBypass,
      offerDescription: formValues.offerDescription,
      landlineService : formValues.landlineService ,
      name: formValues.name,
      notifySPFailProcess: formValues.notifySPFailProcess,
      offerName: formValues.offerName,
      partnerId: formValues.partnerId.id,
      partnerServiceId: formValues.vendorServiceId?.id ? formValues.vendorServiceId?.id : null,
      productName: formValues.name,
      realmId: "426",
      shortCode: '1',
      alphaTag: 'Vivo',
      superVendor: formValues.superVendor,
      vendorService: formValues?.superVendor ? formValues?.vendorService : null,
      vendorId: formValues.vendorId?.id ? formValues.vendorId?.id : null,
      vendorServiceId: formValues.vendorServiceId?.id ? formValues.vendorServiceId?.id : null,
      scheduleBundleOptout: formValues?.scheduleBundleOptout
    }
    return bundle
  }

  public createBundleConstituents(formValues){
    const url = `/${this.baseURL}/bundle/create/products`;
    formValues.map(data => {
      data.realmId = "426";
    });
    return this.http.post(url, formValues);
  }

  public createBundleProductCoexistence(formValues, bundleId, offerId){
    const url = `/${this.baseURL}/bundle/${offerId}/products/${bundleId}/exclusionOffers/create`;
    let body = {bundleId: bundleId, offersId: []};
    formValues.map(form => {
      body.offersId.push(form.offerId);
    });
    return this.http.post(url, body);
  }

  public createBundleCoexistence(formValues, bundleId){
    const url = `/${this.baseURL}/bundle/create/exclusionOffers`;
    let body = {bundleId: bundleId, offersId: []};
    formValues.map(form => {
      body.offersId.push(form.offerId);
    });
    return this.http.post(url, body);
  }

  public getOfferDetails(offerId: number): Observable<any> {
    const url = `/api/webapp-mep-maxis-admin/products/${offerId}`;

    return this.http.get<any>(url).pipe(pluck('responseData'));
  }

  public getOffersByProduct(productId: number): Observable<any> {
    // TODO: Waiting for BE to migrate endpoint
    const url = `/api/webapp-mep-maxis-admin/products/productDefs/${productId}/products`;

    return this.http.get<any>(url).pipe(pluck('responseData'));
  }

  public getProductsByPartnerId(id: number): Observable<any> {
    const url = `/api/webapp-partnerhub-admin/partners/${id}/products`;

    return this.http.get<any>(url).pipe(pluck('responseData'));
  }

  public getBundleById(bundleId): any {
    const url = `/${this.baseURL}/bundle/${bundleId}`;
    return this.http.get(url);
  }

  public getBundleCommunicationsById(bundleId): any {
    const url = `/${this.baseURL}/bundle/${bundleId}/communication`;
    return this.http.get(url);
  }

  public getAllBundles = (
    offset: number = 1,
    pageIncrement: number = 10000,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Bundle[]> => {
    const url =
      `/${this.baseURL}/bundle?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Bundle[]>(url);
  }

  public getBundles = (
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Bundle[]> => {
    const url =
      `/${this.baseURL}/bundle?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Bundle[]>(url);
  }

  public getBundlesCount = (globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/bundle/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getBundlesProducts = (
    bundleId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any, 
    inactiveProducts = false
  ): Observable<Product[]> => {
    const url =
      `/${
        this.baseURL
      }/bundle/${bundleId}/products?inactiveProducts=${inactiveProducts}&page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Product[]>(url);
  }

  public getBundlesProductsCount = (bundleId: number, globalFilter?: any, myFilters?: any, inactiveProducts = false): Observable<number> => {
    const url = `/${this.baseURL}/bundle/${bundleId}/products/count?inactiveProducts=${inactiveProducts}` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getBundlesCoexistence = (
    bundleId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Object> => {
    const url =
      `/${
        this.baseURL
      }/bundle/${bundleId}/exclusionOffers?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get(url);
  }

  public getBundlesCoexistenceCount = (bundleId: number, globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/bundle/${bundleId}/exclusionOffers/count?` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getBundlesDisable = (
    bundleId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any,
    inactiveProducts = true
  ): Observable<Object> => {
    const url =
      `/${
        this.baseURL
      }/bundle/${bundleId}/products?inactiveProducts=${inactiveProducts}&page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(
        sortOrder
      )}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get(url);
  }

  public getBundlesDisableCount = (bundleId: number, globalFilter?: any, myFilters?: any, inactiveProducts = true): Observable<number> => {
    const url = `/${this.baseURL}/bundle/${bundleId}/products/count?inactiveProducts=${inactiveProducts}&` +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public getAddons = (
    bundleId: number,
    productId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Bundle[]> => {
    const url =
      `/${this.baseURL}/bundle/${bundleId}/${productId}/get-addon-details?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Bundle[]>(url);
  }

  public getAddonsCount = (bundleId: number, productId: number, globalFilter?: any, myFilters?: any): Observable<Bundle[]> => {
    const url =
      `/${this.baseURL}/bundle/${bundleId}/${productId}/get-addon-details?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<Bundle[]>(url);
  }

  public updateAddons(arr, bundleId, productId){
    const url = `/${this.baseURL}/bundle/${bundleId}/${productId}/update-addon`;
    return this.http.put(url, arr);
  }

  public getNonCoexByBundleId = (
    bundleId: number,
    productId: number,
    offset: number,
    pageIncrement: number,
    sort?: string,
    sortOrder?: number,
    globalFilter?: any,
    myFilters?: any
  ): Observable<Bundle[]> => {
    const url =
      `/${this.baseURL}/bundle/${bundleId}/products/${productId}/exclusionOffers?page=${offset}&size=${pageIncrement}&ascending=${this.tableSortOrderLogic(sortOrder)}` +
      this.tableSortLogic(sort) +
      this.tableGlobalFilterLogic(globalFilter) +
      this.tableFilterLogic(myFilters);
    return this.http.get<Bundle[]>(url);
  }

  public getNonCoexByBundleIdCount = (bundleId: number, productId: number, globalFilter?: any, myFilters?: any): Observable<number> => {
    const url =
      `/${this.baseURL}/bundle/${bundleId}/products/${productId}/exclusionOffers/count?` + this.tableGlobalFilterLogic(globalFilter) + this.tableFilterLogic(myFilters);
    return this.http.get<number>(url);
  }

  public tableSortOrderLogic(sortOrder) {
    return sortOrder === 1 ? (sortOrder = true) : (sortOrder = false);
  }

  public tableSortLogic(sort) {
    return (sort = sort ? '&sort=' + sort : '');
  }

  public tableGlobalFilterLogic(globalFilter) {
    return (globalFilter = globalFilter ? '&globalFilter=' + globalFilter : '');
  }

  public tableFilterLogic(myFilters) {
    if (myFilters) {
      let filters = '';
      let filterFields = Object.keys(myFilters);
      filterFields.map((filterField, i) => {
        const filterValue = myFilters[filterField]?.value
          ? myFilters[filterField].value
          : typeof myFilters[filterField] == 'string'
          ? myFilters[filterField]
          : '';

        if (filterField != 'global' && filterValue) {
          if (i == 0) {
            filters = '&' + filters + filterField + '=' + filterValue;
          } else {
            filters = filters + '&' + filterField + '=' + filterValue;
          }
        }
      });
      return (myFilters = filters);
    } else {
      return (myFilters = '');
    }
  }

  public updateBundleDetails(bundleId, formValues){
    const url = `/${this.baseURL}/bundle/${bundleId}`;
    formValues.vendorId = formValues.vendorId?.id ? formValues.vendorId?.id : null;
    formValues.vendorServiceId = formValues.vendorServiceId?.id ? formValues.vendorServiceId?.id : null;
    return this.http.put(url, formValues);
  }

  public updateProductStatus(bundleId, productId, status){
    const url = `/${this.baseURL}/bundle/${bundleId}/products/${productId}`;
    const body = {
      inactiveProduct: status
    };
    return this.http.patch(url, body);
  }

  public createNonCoexistence(bundleId, productId, formValues){
    console.log("DEBUG bundle:", bundleId, productId, formValues);
    const url = `/${this.baseURL}/bundle/${bundleId}/products/${productId}/exclusionOffers/create`;
    return this.http.post(url, formValues);
  }

  public deleteNonCoexistence(bundleId, productId, coexId){
    let data = {offersId: [coexId]};
    const url = `/${this.baseURL}/bundle/${bundleId}/products/${productId}/exclusionOffers/delete`;
    return this.http.post(url, data);
  }

  public updateBundleCommunication(bundleId, formValues): any {
    const url = `/${this.baseURL}/bundle/${bundleId}/communication`;
    return this.http.put(url, formValues);
  }
}
